import React, { useEffect, useState } from 'react';
import ModalContainer from '../../components/ModalContainer.jsx';
import { Form, Formik } from 'formik';
import GetField from '../../components/GetField.jsx';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { getAllUserRolesService } from '../../services/ticketsServices.js';
import Alert from '../../utils/Alert.js';
import { initialValues, onSubmit, validationSchema } from './editTicketRolesFormikCodes.js';
import { CircularProgress } from '@mui/material';

const EditTicketRoles = () => {
    const [userRoles, setUserRoles] = useState([]);

    const location = useLocation();

    const navigate = useNavigate();

    const { setTickets } = useOutletContext();

    const handleGetAllUserRoles = async () => {
        try {
            const response = await getAllUserRolesService();
            if (response.status === 200) {
                let roles = response.data.map(r => {
                    return {
                        text: r.name,
                        value: r.id
                    };
                });
                // remove "customer" role.
                roles = roles.filter(r => r.value !== 5);
                setUserRoles(roles);
            }
        } catch (error) {
            Alert(`خطا ${error.response?.status || ""}!`, "در دریافت نقش‌ها مشکلی رخ داده است!\nلطفاً مجدداً تلاش کنید.", "error");
            navigate(-1);
        }
    }

    useEffect(() => {
        handleGetAllUserRoles();
    }, []);

    return (
        <ModalContainer
            alwaysOpen={true}
            fullscreen={false}
            title="ویرایش نقش گیرندگان تیکت"
            className="max-w-screen-sm"
        >

            <Formik
                initialValues={initialValues}
                onSubmit={(values, actions) => onSubmit(values, actions, location.state, setTickets, navigate)}
                validationSchema={validationSchema}
                validateOnMount
            >
                {(formik) => {
                    return (
                        <Form className="flex flex-col">
                            {userRoles.length > 0 ? (
                                <div className="w-full sm:w-3/4 mb-4">
                                    <GetField
                                        control="multiselect"
                                        name="user_role"
                                        formikObject={formik}
                                        label="نقش گیرندگان تیکت:"
                                        options={userRoles}
                                        title="نقش گیرندگان تیکت را انتخاب کنید"
                                    />
                                </div>
                            ) : (
                                <div className="w-full text-center mb-4">
                                    <CircularProgress
                                     size={40} 
                                     color="primary"
                                    />
                                </div>
                            )}
                            <div className="w-full">
                                <GetField
                                    control="submitbutton"
                                    disabledButton={true}
                                    formik={formik}
                                    text="تغییر وضعیت"
                                />
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </ModalContainer>
    );
}

export default EditTicketRoles;
